export type TSupportedLanguage = {
  code: string;
  label: string;
  isDefault?: boolean;
};

export const SUPPORTED_LANGUAGES: TSupportedLanguage[] = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch', isDefault: true },
];
